import React from 'react';
import { Clock } from "lucide-react";
import { useTimeRange } from '../../context/TimeRangeContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const TimeRangeFilter = ({ setGlobalRange }) => {
  const { timeRange, setTimeRange } = useTimeRange();

  const handleTimeRangeChange = (value) => {
    setGlobalRange(value);
    setTimeRange(value);
  }

  return (
    <div className="flex items-center gap-2 bg-white/50 rounded-md px-3 py-1.5 border border-gray-100">
      <Clock className="h-4 w-4 text-gray-500" />
      <span className="text-sm text-gray-600 font-medium">Time Range:</span>
      <Select value={timeRange} onValueChange={(value) => handleTimeRangeChange(value)}>
        <SelectTrigger className="border-none shadow-none focus:ring-0 p-0 h-auto min-w-0 w-auto bg-transparent">
          <SelectValue placeholder="Select time range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="24h">24 Hours</SelectItem>
          <SelectItem value="48h">48 Hours</SelectItem>
          <SelectItem value="72h">72 Hours</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default TimeRangeFilter;
